export default "__VITE_ASSET__7e1d21b4__"